import { Suspense, lazy, useEffect, useState } from "react";
import { Header } from "@/components/Header";
import { HeroSection } from "@/components/HeroSection";
import { StatsSection } from "@/components/StatsSection";
import { Footer } from "@/components/Footer";
import { BottomNav } from "@/components/BottomNav";
import { SEO } from "@/components/SEO";

// Only the layout for the current screen size is rendered. MobileHome is
// bundled eagerly because its category photos are the mobile LCP element;
// lazy-loading it delayed LCP by several seconds.
import { MobileHome } from "@/components/mobile/MobileHome";
const DesktopBelowFold = lazy(() => import("@/components/home/DesktopBelowFold"));

const MOBILE_QUERY = "(max-width: 767px)";

function useIsMobileSync() {
  const [isMobile, setIsMobile] = useState(() =>
    typeof window !== "undefined" ? window.matchMedia(MOBILE_QUERY).matches : false,
  );
  useEffect(() => {
    const mql = window.matchMedia(MOBILE_QUERY);
    const onChange = () => setIsMobile(mql.matches);
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, []);
  return isMobile;
}

const Index = () => {
  const isMobile = useIsMobileSync();

  return (
    <div className="flex min-h-screen flex-col">
      <SEO
        title="TaskRatel — Book Verified Artisans & Handymen in Africa"
        description="Find, chat with, and hire verified handymen, electricians, plumbers, and skilled professionals across Africa. Book securely in minutes."
        path="/"
      />
      <Header />

      {isMobile ? (
        <main className="flex-1 pb-16">
          <Suspense fallback={<div className="min-h-screen" />}>
            <MobileHome />
          </Suspense>
        </main>
      ) : (
        <main className="flex-1">
          <HeroSection />
          <StatsSection />
          <Suspense fallback={<div className="min-h-[60vh]" />}>
            <DesktopBelowFold />
          </Suspense>
        </main>
      )}

      <Footer />
      <BottomNav />
    </div>
  );
};

export default Index;
